import styled from 'styled-components';
import { newColors } from '~/themes/variables';
export const Button = styled.button `
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  color: ${newColors.grey800};
  background: none;
  border: 0;
  text-decoration: none;
  &:hover {
    text-decoration-line: underline;
  }
`;
